import Vue from 'vue'
import axios from 'axios';

// login
Vue.prototype.$Login = async (email,senha,token) => {
  try {
    let res = await axios.post('auth/login', {
      email: email,
      password: senha,
      token: token,
    });
    sessionStorage.setItem("token", res.data.access_token);

  } catch (e) {
    return e;
    //throw e;
  }
}

//login Cidadão
Vue.prototype.$LoginCidadao = async (email,senha,token) => {
  try {
    let res = await axios.post('auth/loginCidadao', { 
      email: email,
      password: senha,
      token: token,
    });
    sessionStorage.setItem("token", res.data.access_token);

  } catch (e) {
    return e;
    //throw e;
  }
}

// login me com axios
Vue.prototype.$meuLogin = async () => {
  try {
    let res = await axios.post('auth/me');
    return res.data;
  } catch (e) {
    throw e;
  }
}

// login me cidadao com axios
Vue.prototype.$meuLoginCidadao = async () => {
  try {
    let res = await axios.post('auth/meCidadao');
    return res.data;
  } catch (e) {
    throw e;
  }
}

//logout
Vue.prototype.$logout = async () => {
  try {
    let res = await axios.post('auth/logout');
    return res.data;
  } catch (e) {
    throw e;
  }
}

//trocar senha
Vue.prototype.$trocarSenhaLogin = async (email,token) => {
  try {
    let res = await axios.post('ouv/v1/mail/tipo/login/novasenha', {
      email: email,
      token: token,
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}


